import { ReactElement, Dispatch, SetStateAction } from 'react';
import { Container, styled, useMediaQuery, Card } from '@mui/material';
import { PDFModal, TabPanel, useRoleOpContext } from '../common';
import { useTeamRequest } from '../team-request';
import { labels, panels, TeamNav } from '.';
import {
  find as lfind,
  propOr as lpropOr,
  compose as lcompose,
} from 'lodash/fp';

export const TeamTabs = ({
  currentTab,
  setCurrentTab,
}: {
  currentTab: number;
  setCurrentTab: Dispatch<SetStateAction<number>>;
}) => {
  const { operations } = useRoleOpContext();

  const currentLabel = lcompose(lpropOr('', `[${currentTab}].label`))(
    labels(operations)
  );

  const { teamRequestState, dispatchTeamRequest } = useTeamRequest();

  const child = (
    <Article>
      <section className="flex-align-items-baseline-justify-content-space-between margin-top-1 margin-left-1">
        <PDFModal
          fileUrl={'Registrants and Coordinators.pdf'}
          fileLabel={'registrant and coordinator instructions'}
          fileDownload="registrants_and_coordinators.pdf"
        />
        <a
          style={{ marginRight: '50%' }}
          href={`${import.meta.env.VITE_SAILPOINT_APPROVE_URL}`}
          target="_blank"
          rel="noreferrer">
          Pending Approval Tasks
        </a>
      </section>

      <TeamNav
        currentTab={currentTab}
        operations={operations}
        setCurrentTab={setCurrentTab}
      />

      {currentLabel !== '' && (
        <TabPanel value={currentTab} label={currentLabel}>
          {lfind<{
            value: number;
            panel: () => ReactElement;
          }>({ value: currentTab })(
            panels({ teamRequestState, dispatchTeamRequest })
          )!.panel()}
        </TabPanel>
      )}
    </Article>
  );

  const matchesGridBreakpoint = useMediaQuery('(min-width:60em)', {
    noSsr: true,
  });

  return matchesGridBreakpoint ? (
    <Container maxWidth="xl" style={{ padding: 0 }} data-testid="team-testid">
      <Card>{child}</Card>
    </Container>
  ) : (
    child
  );
};
const Article = styled('article')(({ theme }) => ({
  minHeight: '76vh',
  overflowY: 'auto',

  '& > *+*': {
    marginTop: '2rem',
  },
}));
